import isPageMeantForPwa from "../isPageMeantForPwa";
/*
**Checking whether the loaded page is meant for the pwa or not
* If not and it is opened in the pwa, redirection should occur and the job search page should open
 */
function isPwaPage(jobSearch = "") {
    const root = location.protocol + '//' + location.host;
    const searchPage = jobSearch !== "" ? jobSearch : (root + "/jobsuche");
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if(isStandalone && !(isPageMeantForPwa())) {
        window.open(searchPage,"_self")
    }
}

export default isPwaPage;
